<template>
    <el-dialog
        v-if="isDialogVisible"
        :visible="true"
        @close="onFormClose"
        :title="title"
    >
        <loading v-if="isFormBusy"></loading>
        <form-wrapper
            v-show="!isFormBusy"
            :get-form-url="getFormUrl"
            @initialized="this.onFormInitialized"
            @initialization-error="this.onFormInitializationError"
            @updated="onUpdated"
        ></form-wrapper>
    </el-dialog>
</template>

<script>
  import eventBus from "../../../../event-bus";
  import FormWrapper from "./form-wrapper";
  import Loading from "../../../loading";


  export default {
    components: {
      FormWrapper,
      Loading,
    },

    data() {
      return {
        getFormUrl: null,
        isFormBusy: true,
        title: null,
      };
    },

    computed: {
      isDialogVisible() {
        return !_.isNull(this.getFormUrl);
      }
    },

    methods: {
      /**
       * @param {*} payload
       */
      showForm({title, url, model}) {
        this.getFormUrl = url;
        this.title = title || 'FORM';
      },

      /**
       * @return {undefined}
       */
      onFormClose() {
        this.destroyForm();
      },

      /**
       * @return {undefined}
       */
      onFormInitialized() {
        this.isFormBusy = false;
      },

      /**
       * @return {undefined}
       */
      destroyForm() {
        this.isFormBusy = true;
        this.getFormUrl = null;
      },

      /**
       * @param {Object} value
       */
      onFormInitializationError({message}) {
        this.destroyForm();
        message && this.$message.error(message);
      },

      /**
       * @param {Object} value
       */
      onUpdated({model, message}) {
        this.destroyForm();
        message && this.$message.success(message);
        eventBus.$emit('send-list-conversation-updated', {model});
      },
    },

    created() {
      eventBus.$on('show-send-list-conversation-modal-form', this.showForm);
    },

    beforeDestroy() {
      eventBus.$off('show-send-list-conversation-modal-form', this.showForm);
    },
  }
</script>

